import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseAuth, firebaseDatabase } from '@/services/firebase'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    collabs: [],
  },
  mutations: {
    setCollabs(state, payload) {
      state.collabs = payload
    },
    insertCollab(state, payload) {
      state.collabs.push(payload)
    },
    removeCollab(state, payload) {
      console.log('removeCollab started')
      console.log(state.collabs)
      console.log(payload)
      state.collabs.filter(item => {
        return item.collabID !== payload
      })
    },
  },
  actions: {
    async getCollabs(context) {
      const collabsPayload = []
      firebaseDatabase.collection('collabs')
        .where('userID', '==', firebaseAuth.currentUser.uid)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              collabID: doc.id,
              collabURL: doc.data().collabURL,
              thumbnailUrl: doc.data().thumbnailUrl,
              channelName: doc.data().channelName,
              subscriberCount: doc.data().subscriberCount,
              videoCount: doc.data().videoCount,
              userID: doc.data().userID,
            }
            collabsPayload.push(data)
          })
        })

      context.commit('setCollabs', collabsPayload)
    },
  },
  getters: {
    state: state => state,
  },
}
